/**
 * Determines whether the current device is physically a mobile phone or tablet,
 * regardless of orientation (portrait vs landscape) or viewport width.
 */
export function isMobileOrTabletDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';

  // 1. Standard mobile/tablet User-Agent (iPhone, iPod, Android phones/tablets, etc.)
  const isMobileUa = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  if (isMobileUa) {
    return true;
  }

  // 2. Modern iPadOS (reports as MacIntel/Macintosh in UA, but possesses multi-touch)
  const isMac = navigator.platform === 'MacIntel' || ua.includes('Mac');
  const isIPad = isMac && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
  if (isIPad) {
    return true;
  }

  // 3. Fallback for touch-first devices with no fine hover pointer
  if (typeof window.matchMedia === 'function') {
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const noFineHover = window.matchMedia('(hover: none)').matches;
    if (hasCoarsePointer && noFineHover) {
      return true;
    }
  }

  return false;
}
